


























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
const win: any = window;

@Component({
  components: {
  }
})
export default class StockNoData extends Vue {
  @Prop() private readonly showSelect!: any; // 是否显示单选框
  @Prop() private readonly config!: any; // 无数据配置


  /**
   * 通知父组件单选框值改变了
   * @param { string } value 当前选中单选框的值
   * @returns {} 
   */
  private handleChange(value: any) {
    this.$emit('change', value);
  }
}
